import React from 'react';
import HostPortalStore from './HostPortalStore';
import HostPortalActions from './HostPortalActions';
import BookAParty from './BookAParty';
import PartyDetails from './PartyDetails';
import moment from 'moment';
import storage from 'storage';

export default class MyPartyListContainer extends React.Component {
	constructor(props) {
		super(props);
		moment.locale(window.jenkon.language);
		this.state = HostPortalStore.getState();
		this.onChange = this.onChange.bind(this);
	}

	componentDidMount() {
		HostPortalStore.listen(this.onChange);
		HostPortalActions.getHostPartyList();
	}

	componentWillUnmount() {
		HostPortalStore.unlisten(this.onChange);
	}

	onChange(state) {
		this.setState(state);
	}

	openPartyDetails(party) {
		this.props.setView(PartyDetails, party.code);
	}

	displayAddress(address) {
	    if (address == null) return "---";
		let line1 = address.line1 != null && address.line1 != '' ? address.line1 + ', ' : '';
		let city = address.city != null && address.city != '' ? address.city + ', ' : '';
		let state = address.stateProvince != null && address.stateProvince != '' ? address.stateProvince : '';
		let addressString = line1 + city + state;
		return addressString
	}

	setLSAndRedirect() {
		storage.set('selectedReason', 'BookAParty');
		storage.set('returnUrl', window.location.href);
		window.location.href = `${window.jenkon.consultantRoot}mystory`;
	}

	createEventList(party, i) {
		return (
			<div className="partyItem clearfix" key={i} onClick={this.openPartyDetails.bind(this, party)}>
				<div className="partyDate">
					<span className="partyName"><a>{party.name}</a></span>
					<br />
					<span className="subtext">{party.isVirtual ? moment(party.startDate).format('ll') + ' - '
						+ moment(party.endDate).format('ll') : moment(party.eventDate).format('ll') + ' @ '
						+ moment(party.eventDate).format('hh:mm') + ' ' + party.timeZone}</span>

				</div>
				<div className="partyLocation">{party.isVirtual ?  this.props.resources["PWS.MyAccount.MyPartiesLocationOnline"] : this.displayAddress(party.address)}</div>
				<div className="partyPublic">{!party.isPublic ? this.props.resources["PWS.MyAccount.MyPartiesPublicFlagNo"] : this.props.resources["PWS.MyAccount.MyPartiesPublicFlagYes"]}</div>
				<div className="partyTotal" style={{textAlign: 'right', display: 'none'}}>{party.totalEventSales != null ? party.totalEventSales.displayValue : "---"}</div>
				<div className="partyStatus">{party.eventStatus}</div>
			</div>
		)
	}

	render() {
		return (
			<div id="my-addresses-section" className="site-container icon_button_content animate-in" aria-live="assertive">
				<div className="blurb text-center">
					<div className="title">{this.props.resources["PWS.MyAccount.MyPartiesTitle"]}</div>
					<div className="description">{this.props.resources["PWS.MyAccount.MyPartiesPageDescription"]}</div>
				</div>
				<div className="section-wrapper clearfix">
					<a href="javascript:void(0);" className="section-back-link" onClick={this.props.setView.bind(this)}>&laquo; &nbsp;{this.props.resources["PWS.MyAccount.BackToAccountButton"]}</a>
					<div className="dotted-HR"></div>
					<div className="sectionButtons" style={{textAlign: 'center', margin: '12px 0'}}>
						<button className="bookPartyBtn" onClick={this.setLSAndRedirect}>{this.props.resources['PWS.Events.ContactMeButton']}</button>
					</div>
				</div>
				<div className="columnHeader partyItem clearfix">
					<div className="partyDate">{this.props.resources["PWS.MyAccount.MyPartiesPartyNameColumnHeader"]}</div>
					<div className="partyLocation">{this.props.resources["PWS.MyAccount.MyPartiesLocationColumnHeader"]}</div>
					<div className="partyPublic" style={{textAlign: 'left'}}>{this.props.resources["PWS.MyAccount.MyPartiesPublicFlagColumnHeader"]}</div>
					<div className="partyTotal" style={{textAlign: 'right', display: 'none'}}>{this.props.resources["PWS.MyAccount.MyPartiesPartyTotalColumnHeader"]}</div>
					<div className="partyStatus" style={{textAlign: 'right'}}>{this.props.resources["PWS.MyAccount.MyPartiesPartyStatusColumnHeader"]}</div>
				</div>
				{this.state.MyPartiesList.map(this.createEventList.bind(this))}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/HostPortal/MyPartyListContainer.js